import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {environment} from '../../../environments/environment';

/**
 * Route guard that ensures that there is a user admin of his company
 */
@Injectable()
export class IsNotProd {

    constructor(
        private readonly auth: AuthService,
        readonly router: Router
    ) {
    }

    /** Validates authentication for a specific route. */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.auth.auth;

        if (!environment.production) {
            return true;
        } else {
            this.router.navigate(['404']);
            return false;
        }
    }

    /** Validates authentication for children of a route. */
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(childRoute, state);
    }

}
